<template>
	<v-app id="app">
		<v-main class="grey lighten-5">
			<router-view />
		</v-main>
		<ChamaileonFlashToast />
	</v-app>
</template>

<script>
export default {
	name: "App",
	mounted() {
		this.$store.dispatch("sso/initCognitoUserPool");
	},
};
</script>
